<script setup lang="ts">
import { faAdd } from '@fortawesome/pro-regular-svg-icons';
import { SearchMode } from '@utils/types';
import SearchReserveForm from '@components/util/search/SearchReserveForm.vue';
import { ReserveType } from '@utils/itinerary';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();

const bundleForm = useBundleForm();
const i18n = useI18n();
const form = useTripSearchForm(isChangeSearch);
const bundleOptions = [
    {
        label: 'هتل + هواپیما',
        value: SearchMode.Domestic,
        href: '/tour',
    },
];
const removeRoom = (i: number) => bundleForm.removeRoom(i);
const addRoom = () => bundleForm.addRoom();
</script>

<template>
    <SearchReserveForm
        v-bind="form"
        :search-mode-options="bundleOptions"
        :loading
        :reserve-type="ReserveType.Bundle"
        :origin-title="i18n.t('SearchFlightForm.origin')"
        :destination-title="i18n.t('SearchFlightForm.destination')"
        :datepicker-options="{ forceRange: true }"
        :pax-picker-options="{
            prefix: `${form.searchPaxModel.value.length} اتاق، `,
        }"
        :is-change-search
        @delete="removeRoom"
    >
        <template #pax-picker-content>
            <mr-divider key="button-divider" class="button-divider" />
            <mr-button
                class="add-room-button"
                variant="transparent"
                :right-icon="faAdd"
                @click="addRoom"
            >
                افزودن اتاق
            </mr-button>
        </template>
    </SearchReserveForm>
</template>

<style scoped lang="scss">
.add-room-button {
    align-self: flex-start;
}
.button-divider {
    margin: 0 0 12px 0;
}
</style>
